import Pqp from "../3x1010/Pqp";

export default class ListSelect {
	constructor(options) {
		this.options = options;
		this.provider = options.provider;
		this.callback = options.handler;
		this.multiple = options.multiple;
		this.clips = new Array();
		this.selected = new Array();
		this.curh = -1;
		this.lastResults = new Array();
	}

	init() {
		this.data = this.provider.filter((el) => this.options.entries.indexOf(el.Value) === -1);

		this.build();

	}

	destroy() {
		jQuery(window).off("keydown.lsel");
	}


	build() {
		let mc = jQuery("#template-list-select").clone();
		mc.removeAttr("id");
		jQuery("body").append(mc);
		mc.show();
		this.mc = mc;
		// Title
		let title = "Select";
		//if (this.options.title) {
		//	title += " a " + this.options.title + "..."
		//} else {
		//	title + "..."
		//}
		title = this.options.title;
		jQuery(".js-list-title", this.mc).text(title);
		jQuery(".js-list-text", this.mc).focus();
		jQuery(".js-close", this.mc).on("click", this.closeListSelect.bind(this));

		let tmps = new Array();
		for (let x = 0; x < ListSelect.MAX_RESULTS_FOR_HEIGHT; x++) {
			let tmp = jQuery(".ls-result-template", this.mc).clone();
			tmp.removeClass("ls-result-template");
			jQuery(".js-results", this.mc).append(tmp);
			tmps.push(tmp);
		}

		let h = jQuery(".js-results-block", this.mc).height();
		for (let x = 0; x < ListSelect.MAX_RESULTS_FOR_HEIGHT; x++) {
			tmps[x].remove();
		}
		jQuery(".js-results-block", this.mc).height(h);

		jQuery(".js-hint", this.mc).show();
		jQuery("span", jQuery(".js-hint", this.mc)).text("" + ListSelect.MIN_CHARS);
		jQuery(".js-list-text", this.mc).attr("placeholder", "min " + ListSelect.MIN_CHARS + " chars...");

		jQuery(".js-list-text", this.mc).on("propertychange input paste", this.textChanged.bind(this));
		this.mc.on("wheel", this.onWheel.bind(this));

		jQuery(".js-show-all", this.mc).on("click", this.showAll.bind(this));


		if (this.multiple) {
			jQuery(".js-show-all", this.mc).hide()
			jQuery(".js-confirm", this.mc).on("click", this.selectionDone.bind(this));
			this.refreshSelected();
		} else {
			jQuery(".js-confirm", this.mc).hide()
			jQuery(".js-selected-details", this.mc).hide();
		}

		jQuery(window).on("keydown.lsel", jQuery.proxy(this.onKeyPress, this));


	}
	onWheel(e) {
		//debugger
		/*if (this.lastResults) {
			if (this.lastResults.length <= ListSelect.MAX_RESULTS) {
				e.preventDefault();
			}
		}*/

		if (jQuery(".js-results-block", this.mc).height() === jQuery(".js-results", this.mc).height()) {
			e.preventDefault();
		}

		if (jQuery(".js-results-block", this.mc).scrollTop() === 0) {
			if (e.originalEvent.deltaY < 0) {
				e.preventDefault();
			}
		}

		if (jQuery(".js-results-block", this.mc).scrollTop() + jQuery(".js-results-block", this.mc).height() >= jQuery(".js-results", this.mc).height()) {
			if (e.originalEvent.deltaY > 0) {
				e.preventDefault();
			}
		}


		if (!jQuery(e.target).hasClass("ls-result")) {
			e.preventDefault();
		}
	}

	closeListSelect() {
		this.destroy();
		this.mc.remove();

	}

	textChanged() {
		this.selected = new Array();
		this.curh = -1;
		this.lastResults = new Array();
		let txt = jQuery.trim(jQuery(".js-list-text", this.mc).val()).toLowerCase();
		this.typed = txt;
		if (this.options.removeDiacritics) {
			txt = Pqp.removeDiacritics(txt);
		}
		this.lastSearch = txt;
		if (txt.length >= ListSelect.MIN_CHARS) {
			this.showMessage("search");
			clearTimeout(this.idto);
			this.idto = setTimeout(this.doSearch.bind(this, txt), ListSelect.TIME_IDLE_BEFORE_SEARCHING);
		} else {
			this.removeResults();
			this.hideNumResults();
			this.showMessage("hint");
		}
	}

	doSearch(txt) {
		let res;
		if (this.options.removeDiacritics) {
			res = this.data.filter((el) => el.Label ? Pqp.removeDiacritics(el.Label.toLowerCase()).indexOf(txt) !== -1 : false);
		} else {
			res = this.data.filter((el) => el.Label ? el.Label.toLowerCase().indexOf(txt) !== -1 : false);
		}
		this.showResults(res);
	}

	showMessage(cls) {
		jQuery(".js-message", this.mc).hide();
		jQuery(".js-" + cls, this.mc).show();
	}

	showResults(res) {
		this.lastResults = res;
		this.setNumResults();
		this.doShowResults(false);

	}

	doShowResults(all) {
		if (this.multiple) {
			all = true;
		}

		//let txt = jQuery.trim(jQuery(".js-list-text", this.mc).val());
		this.removeResults();
		let res = this.lastResults;
		let limit = ListSelect.MAX_RESULTS;
		if (all) {
			limit = res.length;
		}
		if (limit > res.length) {
			limit = res.length;
		}


		for (let x = 0; x < limit; x++) {
			let clip = jQuery(".ls-result-template", this.mc).clone();
			clip.removeClass("ls-result-template");
			clip.text(res[x].Label);
			this.clips.push(clip)
			clip.on("click", this.clipSelected.bind(this, res[x], clip,x));
			jQuery(".js-results", this.mc).append(clip);
		}

		this.mark = new Mark(jQuery(".js-results", this.mc));
		this.mark.mark(this.lastSearch);
	}


	removeResults() {
		for (let x = 0; x < this.clips.length; x++) {
			this.clips[x].remove();
		}
		this.clips = new Array();
	}

	hideNumResults() {
		jQuery(".js-block-num-results", this.mc).css({
			opacity: 0,
			"pointer-events": "none"
		});
	}

	setNumResults() {

		jQuery(".js-block-num-results", this.mc).css({
			opacity: 1,
			"pointer-events": "all"
		});

		this.showMessage("none");

		if (this.lastResults.length === 0) {
			this.showMessage("no-result");
			this.hideNumResults();

		} else {
			jQuery(".js-num-results", this.mc).text("" + this.lastResults.length);
			if (this.lastResults.length <= ListSelect.MAX_RESULTS) {
				jQuery(".js-show-all", this.mc).css("opacity", 0);
				jQuery(".js-show-all", this.mc).css("pointer-events", "none");
			} else {
				jQuery(".js-show-all", this.mc).css("opacity", 1);
				jQuery(".js-show-all", this.mc).css("pointer-events", "all");
			}
		}
	}

	showAll() {
		jQuery(".js-show-all", this.mc).css("opacity", 0);
		jQuery(".js-show-all", this.mc).css("pointer-events", "none");
		this.doShowResults(true);
	}

	clipSelected(o, clip, index) {
		this.curh = index;
		if (this.multiple) {
			if (this.alreadySelected(o)) {
				clip.removeClass("active");
				this.removeFromSelected(o);
			} else {
				if (this.options.max !== -1) {
					if (this.selected.length < this.options.max) {
						clip.addClass("active");
						this.addToSelected(o);
					}
				} else {
					clip.addClass("active");
					this.addToSelected(o);
				}
			}
			this.refreshSelected();
		} else {
			if (this.callback) {
				this.callback.call(null, { type: ListSelect.EVENT_SELECTED, data: [o], payload: this.options.payload });
			}
			this.closeListSelect();
		}
	}

	selectionDone() {
		if (this.callback) {
			this.callback.call(null, { type: ListSelect.EVENT_SELECTED, data: this.selected, payload: this.options.payload });
		}
		this.closeListSelect();

	}


	refreshSelected() {
		jQuery(".js-num-selected", this.mc).text("" + this.selected.length);
		if (this.options.max !== -1) {
			jQuery(".js-num-max", this.mc).text("" + this.options.max);
		} else {
			jQuery(".js-max", this.mc).hide();
		}
		if (this.selected.length === 0) {
			jQuery(".js-confirm", this.mc).css("opacity", 0.5);
			jQuery(".js-confirm", this.mc).css("pointer-events", "none");
		} else {
			jQuery(".js-confirm", this.mc).css("opacity", 1);
			jQuery(".js-confirm", this.mc).css("pointer-events", "all");
		}
	}

	alreadySelected(o) {
		for (let x = 0; x < this.selected.length; x++) {
			if (this.selected[x].Value === o.Value) {
				return true;
			}
		}
		return false;
	}

	removeFromSelected(o) {
		let tmp = new Array();
		for (let x = 0; x < this.selected.length; x++) {
			if (this.selected[x].Value !== o.Value) {
				tmp.push(this.selected[x]);
			}
		}
		this.selected = tmp;
	}

	addToSelected(o) {
		this.selected.push(o);
	}

	onKeyPress(e) {
		var code = e.keyCode;
		if ((code === 34) || (code === 33)) {
			e.preventDefault();
			return
		}
		if ((code === 38) || (code === 40) || (code === 13) || (code === 32)) {
			if (code === 13) {
				this.selectHilighter();
				e.preventDefault();
			} else if (code === 32) {
				e.preventDefault(); //fare in modo furbo
				if (this.multiple) {
					this.toggleEntry();
				} else {
					this.selectHilighter();
				}
			} else {
				this.moveHilighter(code);
				e.preventDefault();
			}
		}
	}

	toggleEntry() {
		if (this.lastResults.length === 0) {
			return;
		}
		this.clipSelected(this.lastResults[this.curh], this.clips[this.curh], this.curh);
	}

	selectHilighter() {
		if (this.lastResults.length === 0) {
			return;
		}
		if (this.multiple) {
			if (this.selected.length > 0) {
				this.selectionDone();
			}
		} else {
			this.toggleEntry();
			this.selectionDone();
		}

	}

	moveHilighter(code) {
		if (this.lastResults.length === 0) {
			return;
		}

		if (code === 38) {
			// su
			this.curh--;
			if (this.curh < -1) {
				this.curh = this.lastResults.length - 1;
			}
		} else if (code === 40) {
			// giu
			this.curh++;
			if (this.curh >= this.lastResults.length) {
				this.curh = -1; 
			}
		}

		for (let x = 0; x < this.clips.length; x++) {
			this.clips[x].removeClass("ls-results-highlighted");
		}
		if (this.curh !== -1) {
			//debugger
			this.clips[this.curh].addClass("ls-results-highlighted");
			this.putClipInView(this.clips[this.curh], code);
		} else {
			jQuery(".js-results-block", this.mc).scrollTop(0);
		}

	}

	putClipInView(clip, code) {
		let offset = jQuery(".js-results", this.mc).position().top;
		let pos = clip.position().top - offset;
		let he = clip.outerHeight();
		let hview = jQuery(".js-results-block", this.mc).height();
		let curscroll = jQuery(".js-results-block", this.mc).scrollTop();
		if (code === 38) {
			// su
			if (pos < curscroll) {
				jQuery(".js-results-block", this.mc).scrollTop(pos);
			} else if (pos + he > curscroll + hview) {
				jQuery(".js-results-block", this.mc).scrollTop(pos);
			}
		} else {
			// giu
			if (pos + he > curscroll + hview) {
				jQuery(".js-results-block", this.mc).scrollTop(pos - hview + he);
			} else if (pos < curscroll) {
				jQuery(".js-results-block", this.mc).scrollTop(pos );
			}
		}
	}

}

ListSelect.TIME_IDLE_BEFORE_SEARCHING = 200;
ListSelect.MIN_CHARS = 3;
ListSelect.MAX_RESULTS = 10;
ListSelect.MAX_RESULTS_FOR_HEIGHT = 5;

ListSelect.EVENT_SELECTED = "eventSelected";
